module.exports = __webpack_public_path__ + "static/media/projects-code.12932e38.svg";